var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("warehouse-new-page", {
        ref: "warehouseNewPage",
        attrs: { context: _vm.context, action: _vm.action }
      }),
      _vm.job.loadingTerm == "DD"
        ? _c("trucking-page", {
            ref: "truckingPage",
            attrs: { context: _vm.context, action: _vm.action }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }